import { getBucktFileApi } from './CampManagementService'

export const sucessErrorMsg = {
  companySucessMsg: 'sucess fecting Company details',
  companyErrorMsg: 'error fetching Company details',
  recordingUnavailableMsg:
    'Recording facility unavailable. You can still continue with the call.',
  meetingLinkErrorMsg: 'Failed to start meeting.',
  tokenFetchError: 'Failed to fetch token',
  noKeyReturned: 'Failed to fetch Jitsi token: No key returned',
}

export const lmsIntent = {
  getOrderInvoices: 'getOrderInvoices',
  createOrderEvent: 'createOrderEvent',
  getTestPriceFromOdoo: 'getTestPriceFromOdoo',
  updateLabOrderInvoice: 'updateLabOrderInvoice',
  createLabInvoice: 'createLabInvoice',
  getAllPanelsApi: 'getAllPanelsApi',
  CancelLabOrder: 'CancelLabOrder',
  getAllPriceList: 'getAllPriceList',
  GetLocByID: 'GetLocByID',
  updateLabOrdersShort: 'updateLabOrdersShort',
  buyPackage: 'buyPackage',
  fetchLabOrders: 'FetchLabOrders',
  updateLabOrderPhase: 'updateLabOrderPhase',
}
export const ERROR_DELETE_DOCUMENT = 'Error while deleting document'
export const UPLOAD_FAILED_MSG = 'Upload failed'
export const ERROR_UPLOADING_REFERRAL_DETAILS =
  'Error uploading referral details'
export const constants = {
  joinMeeting: 'Join Meeting',
}
export const JITSI_SECRET_KEY = process.env.REACT_APP_JITSI_SECRET_KEY
export const statusNotEntered = 'status:not=entered-in-error'
export const statusEntered = 'status=entered-in-error'

export const getBucketFile = async (fileUrl: string, fileName: string) => {
  const response = await getBucktFileApi(fileUrl)
  if (response?.success) {
    const blob = new Blob([response?.data], { type: 'application/pdf' })
    const file = new File([blob], fileName, { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    return { pdfFile: file, pdfFileUrl: url }
  }
  return {}
}
